import {isObject} from 'lodash';
import PropTypes from 'prop-types';
import {IntlShape, MessageFormatElement, MessageDescriptor} from 'react-intl';

type PrimitiveType = string | number | boolean | null | undefined | Date;
type FormatXMLElementFn<T, R = string | T | Array<string | T>> = (
  parts: Array<string | T>
) => R;

type TextParams = Record<
  string,
  PrimitiveType | FormatXMLElementFn<string, string>
>;

interface TranslateUtilsTranslateFunction {
  (key: string, intl: IntlShape, textParams?: TextParams): string;

  (key: MessageDescriptor, intl: IntlShape, textParams?: TextParams): string;
}

interface TranslateUtilsFunctions {
  hasTranslation: (
    text: string,
    intl: IntlShape
  ) => boolean | string | MessageFormatElement[];
  translate: TranslateUtilsTranslateFunction;
  isMessageDescriptor: (
    key: string | MessageDescriptor
  ) => key is MessageDescriptor;
}

const TranslateUtils: TranslateUtilsFunctions = {
  isMessageDescriptor(key): key is MessageDescriptor {
    return isObject(key) && !!key.id;
  },

  hasTranslation(text, intl) {
    return text && intl && intl.messages && intl.messages[text];
  },

  translate(
    key: string | MessageDescriptor,
    intl,
    textParams: TextParams | undefined = undefined
  ) {
    const isDescriptor = TranslateUtils.isMessageDescriptor(key);
    const translationKey = isDescriptor ? key.id : key;
    const translationDescriptor = isDescriptor ? key : {id: translationKey};

    if (translationKey && TranslateUtils.hasTranslation(translationKey, intl)) {
      return intl.formatMessage(translationDescriptor, textParams);
    }
    return translationKey;
  },
};

export const intlShape = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});

export default TranslateUtils;
